<template>
    <toolbar-option type="stacked">
        <template slot="secondary">
            <dropdown
                :value="unit"
                :options="unitOptionsNew"
                native
                @input="onUnitInput"
            />
        </template>

        <template slot="primary">
            <collapse id="control-min-height" v-model="slider">
                <slider
                    :value="sliderIndex"
                    :values="themeObjectValues"
                    @input="onInput"
                />
            </collapse>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';

export default {
    name: 'min-height',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Min Height',
            tailwindDefinitionProp: 'minHeight',
            defaultUnit: 'rem',
        };
    },

    computed: {
        unitOptionsNew() {
            const options = this.unitOptions;

            options.unshift({ text: 'None', value: '' });

            return options;
        },
    },

    watch: {
        changedOption({ option }) {
            if (option === 'max-height') this.onConflict();
        },
    },

    methods: {
        onConflict() {
            this.removeFlexClass();
            this.sliderIndex = 0;
            this.unit = '';
        },
    },
};
</script>
